<template>
    <section class="mb-20 px-4">
        <div class="max-w-screen-xl mx-auto text-center">
            <!-- Icon -->
            <div class="max-w-max mx-auto relative mb-8">
                <NuxtImg src="/images/circuit.png" width="298" height="180" alt="Shopping Bag"
                    class="w-40 sm:w-56 md:w-72 lg:w-[298px] h-auto" loading="lazy" />
                <div
                    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-2xl bg-[image:var(--primary-gradient)]">
                    <NuxtImg src="/images/empower-vendor-icon.png" width="36" height="42" alt="Shopping Bag"
                        class="w-6 sm:w-8 md:w-9 h-auto" loading="lazy" />
                </div>
            </div>

            <!-- Heading -->
            <h2
                class="text-xl sm:text-2xl md:text-3xl text-[var(--text-secondary)] font-bold -mt-4 sm:-mt-6 md:-mt-7 mb-4">
                Empower Vendors with a Robust Dashboard
            </h2>
            <p class="text-base sm:text-lg md:text-xl text-[var(--text-gray)] max-w-2xl mx-auto mb-10 px-2">
                Vendors gain complete control over their store with a range of tools
                designed to simplify management and boost performance.
            </p>

            <!-- Dashboard Image -->
            <div class="flex justify-center">
                <NuxtImg src="/images/empower-vendors.png" alt="Vendor Dashboard"
                   width="1280" height="781" class="w-full max-w-7xl rounded-2xl shadow-lg" loading="lazy" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
</script>
